import React from "react";
import { cardData } from "../../Data/ArticleData";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Avatar from '@mui/material/Avatar';
import Footer from '../../Components/Footer'

function Article() {
    let pathName = window.location.pathname;
    let pathe = pathName.replace(/%20/g, " ");
    let path1 = pathe.split("/")[2];
    const currentArticles = cardData.find(
        (article) =>decodeURIComponent(article.title) === decodeURIComponent(path1)
      );
    
console.log(path1)
  return (
    <div className="article" >
     <div className='articleHead'   style={{
                  backgroundImage: `url(${require(`../../images/${currentArticles.img}.jpg`)})`,
                }}>
    
    <h1>
      {currentArticles.title}
    </h1>
    <h6>{currentArticles.tag}</h6>
 </div>
 <div className="articleBody">
 <div className="articleBody1">
    <img  src={require(`../../images/${currentArticles.img}.jpg`)} alt={currentArticles.img} className="articleBodyImg"/>
    <div className="articleDetail1">
    <h3>Publié le <span style={{color:"#e27d24"}}>{currentArticles.date}</span> | dans {currentArticles.tag} </h3>
    {currentArticles.authors.map((author, index) => (
    <h4>  <Avatar key={index} alt={author.name} src={require(`../../images/${author.name}.jpg`)} sx={{ width: 24, height: 24,marginRight:1 }} /> {author.name}</h4>
    
    ))}
    </div>
    <p className="articleDescreption" dangerouslySetInnerHTML={{ __html: currentArticles.description }}/>
 </div>
 <div className="articleBody2">
    <h3>articles similaires </h3>
    {cardData.map((card, index) => (
      (card.tag===currentArticles.tag&&currentArticles.title!==card.title)?(
          <a href={`/articles/${card.title}`} className='cardLink'>
          <div key={index} > <Card
              variant="outlined"
       
              className='ArticelCard'

            >
              <CardMedia
                component="img"
                alt={card.title}
                src={require(`../../images/${card.img}.jpg`)}
                className="card-media"
              />
              <CardContent >
                <h3 className="articelCardTitle">
                  {card.title} |    {card.tag}
                </h3>
                <h3 gutterBottom className="articelCardTitle" >
               
                </h3>
                <h3 className="articelCardTitle" >{card.date}</h3>
              </CardContent>
          
                
               
             
            </Card> </div></a>):(<></>)))}
 </div>
 </div>
 <Footer/>
    </div>
  );
}

export default Article;

